import React from "react";
import {
  ObjectHolidayCssClasses,
  ObjectHolidayTitles
} from "../../insidePages/SpecificationsUIHelper";
import { FormattedMessage } from "react-intl";
export const HolidayColumnFormatter = (cellContent, row) => (
  <span

    className={`label label-lg label-light-${
     
      ObjectHolidayCssClasses[(+!!row.holiday)]
    } label-inline`}
  >
    <FormattedMessage id= {ObjectHolidayTitles[(+!!row.holiday)]}/>
  </span>
);